import { __assign } from "tslib";
// DS9.7.5
import React from 'react';
import DeviationBlockedOverlay from './DeviationBlocked';
import ArtistBlockedOverlay from './ArtistBlocked';
import DefaultBlockedOverlay from './DefaultBlocked';
import AntisocialBlockedOverlay from './AntisocialBlocked';
import { BlockReasons } from '../../Moderation/redux/types';
import MatureAnonymousBlockedOverlay from './MatureAnonymousBlocked';
import MatureBlockedOverlay from './MatureBlocked';
import MatureAgeBlockedOverlay from './MatureAgeBlocked';
import MatureStrictBlockedOverlay from './MatureStrictBlocked';
var BlockedOverlay = function (props) {
    switch (props.blockReason) {
        case BlockReasons.DeviationBlocked:
            return React.createElement(DeviationBlockedOverlay, __assign({}, props));
        case BlockReasons.ArtistBlocked:
            return React.createElement(ArtistBlockedOverlay, __assign({}, props));
        case BlockReasons.MatureFilter:
            return React.createElement(MatureBlockedOverlay, __assign({}, props));
        case BlockReasons.MatureLoggedOut:
            return React.createElement(MatureAnonymousBlockedOverlay, __assign({}, props));
        case BlockReasons.MatureAge:
            return React.createElement(MatureAgeBlockedOverlay, __assign({}, props));
        case BlockReasons.StrictMatureAge:
            return React.createElement(MatureStrictBlockedOverlay, __assign({}, props));
        case BlockReasons.Antisocial:
            return React.createElement(AntisocialBlockedOverlay, __assign({}, props));
        case BlockReasons.BlockedByArtist:
        default:
            return React.createElement(DefaultBlockedOverlay, __assign({}, props));
    }
};
BlockedOverlay.displayName = 'BlockedOverlay';
export default BlockedOverlay;
//# sourceMappingURL=Hidden.js.map